import { ArtworkIcon, ContentIcon } from "@dropbox/dash-component-library";
import { Box, ThemeContainer, ThemeProvider } from "@dropbox/dig-foundations";
import styles from "./AppsFacepile.module.css";

interface AppIconProps {
  icon: React.ComponentProps<typeof ArtworkIcon>["icon"];
}

export const AppIcon = ({ icon }: AppIconProps) => {
  return (
    <Box className={styles.appIconFacepile}>
      <ContentIcon
        size={"small"}
        className={styles.appIcon}
        icon={<ArtworkIcon icon={icon} />}
      />
    </Box>
  );
};

export const AppsFacepile = () => {
  return (
    <Box className={styles.appsFacepileContainer}>
      <ThemeProvider mode="bright">
        <ThemeContainer>
          <AppIcon icon="Notion" />
          <AppIcon icon="MsOutlook" />
          <AppIcon icon="Smartsheet" />
          <AppIcon icon="GoogleMail" />
        </ThemeContainer>
      </ThemeProvider>
    </Box>
  );
};
